
import * as THREE from 'three'
import TWEEN from '@tweenjs/tween.js'
import Stats from 'stats.js';
import { AnimLine } from './AnimLine.js';
import { Color, LineSegments, PlaneBufferGeometry, Vector2, Vector3 } from 'three';
import "./pallettes"
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass} from 'three/examples/jsm/postprocessing/ShaderPass';
import { FilmPass} from 'three/examples/jsm/postprocessing/FilmPass';
import { GlitchPass} from 'three/examples/jsm/postprocessing/GlitchPass';
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass';
import { pallettes } from './pallettes';
import images from './images.json'
//import images from './imagesSmall.json'

var stats = new Stats();
//stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
//document.body.appendChild( stats.dom );

let pIndex = Math.random() * pallettes.length;
pIndex = Math.floor(pIndex);
let getColours = function () { return pallettes[pIndex]; };
let bgIndex= Math.random() * getColours().length;
bgIndex = Math.floor(bgIndex);
let getBgColour = function () { return getColours()[bgIndex]; };
stats.begin();


let animLines = [];
const scene = new THREE.Scene();
const sceneParams = {
  SAVE: function () { saveCanvas() },
  bgcolor: getBgColour(), 
  fogDistance: 20.4,
}
const geometry = new THREE.PlaneGeometry(100, 100);
const material = new THREE.MeshBasicMaterial({ opacity: 0.0, transparent: true, color: getBgColour(), side: THREE.DoubleSide });
const canvas = new THREE.Mesh(geometry, material);
canvas.position.z = (-7.);
const transitionPlane = canvas.clone();
const transitionMat = new THREE.MeshBasicMaterial({ opacity: 1., transparent: true, color: getBgColour(), side: THREE.DoubleSide });
transitionPlane.position.z = -1;
transitionPlane.material = transitionMat;
transitionPlane.renderOrder = 100;
function setBG() {
  //scene.fog = new THREE.Fog(sceneParams.bgcolor, sceneParams.fogDistance, sceneParams.fogDistance + 1.);
  scene.background = new THREE.Color(sceneParams.bgcolor);
}

let raycaster = new THREE.Raycaster();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
let camBounds = {x: 2, y: 2};
let camAnimOffset = { x: 0, y: 0 };
let camMouseOffset = { x: 0, y: 0 };
setBG();

function saveCanvas() {
  renderer.render(scene, camera);
  var screenshot = renderer.domElement.toDataURL("image/png");
  var filename = "canvas_" + new Date().toISOString() + ".png";
  var link = document.createElement('a');
  link.href = screenshot;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

scene.add(canvas);
scene.add(transitionPlane);
const renderer = new THREE.WebGLRenderer({ antialiasing: true });
renderer.setSize(window.innerWidth, window.innerHeight)
renderer.setPixelRatio( window.devicePixelRatio * 1.5 );

let imageTextures= [];
let textureIndex = 0;
let planeMat = new THREE.MeshBasicMaterial({ color: getBgColour(), side: THREE.DoubleSide, transparent: true, depthTest: false, depthWrite: false });
images.images.forEach(image => {
  var loader = new THREE.TextureLoader();
  loader.load('textures/' + image.path,
    function (texture) {
      console.log("loaded: ", image.path);
      imageTextures.push(texture);
      if (textureIndex === imageTextures.length - 1) {
        setPlaneTexture(imageTextures[textureIndex]);
      }
    });
})
let planeGeo = new THREE.PlaneGeometry(3.5, 3.5, 1);
var planeMesh = new THREE.Mesh(planeGeo, planeMat);
planeMesh.position.z = -1;
planeMesh.renderOrder = 2;
scene.add(planeMesh);

textureIndex = Math.floor(Math.random()*images.images.length);
console.log("texture index", textureIndex, imageTextures.length);

function setPlaneTexture(texture) {
  planeMat.alphaMap = texture;
  planeMat.alphaTest = .5;
  planeMat.transparent = true;
  planeMat.needsUpdate = true;
}


document.getElementsByTagName("body")[0].style.marginLeft = "0";
document.getElementsByTagName("body")[0].style.marginTop = "0";
document.getElementsByTagName("body")[0].style.marginBottom = "0";
document.getElementsByTagName("body")[0].style.marginRight = "0";
document.body.appendChild(renderer.domElement)

renderer.domElement.style.outlineStyle = "inset"
renderer.domElement.style.outline= "1px solid"
renderer.domElement.style.outlineColor= "rgba(0,0,0,.3)"
renderer.domElement.style.outlineOffset= "-2.2em"

var isMobile = false; //initiate as false
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  isMobile = true;
}
if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
  isMobile = true; //because some ipads use deskyop browsers just infer it from the touch points
}

function makeNewLineFromEvent(pos, dir) {
  let maxLines = 200;

  raycaster.setFromCamera(pos, camera);
  let results = raycaster.intersectObject(canvas);
  results.forEach((result) => {
    if(animLines.length > maxLines){
      let line = animLines.shift();
      //console.log(line);
      removeLine(line);
    }
    let point = result;
    let colour = new THREE.Color(getColours()[Math.floor(Math.random()*getColours().length)]);
    //while(colour.getHexString() === new THREE.Color(getBgColour()).getHexString())
    //  colour = new THREE.Color(getColours()[Math.floor(Math.random() * getColours().length)]);
    let renderOrder = 1 + Math.floor(Math.random()*6.)
    let newAnimLine = new AnimLine(point.point, dir, 2.11, .6, colour);
    if(renderOrder > 1)
      newAnimLine = new AnimLine(point.point, dir, .8, .5, colour);
    if (renderOrder > 2)
      newAnimLine = new AnimLine(point.point, dir, .5, .2, colour);
    if(renderOrder > 3)
      newAnimLine = new AnimLine(point.point, dir, .1, .4, colour);
    if (renderOrder > 4)
      newAnimLine = new AnimLine(point.point, dir, .05, .2, colour);
    animLines.push(newAnimLine)
    //console.log(renderOrder);
    //if(Math.random() > .8)
    //  renderOrder++
    newAnimLine.lineMesh.renderOrder = renderOrder;
    newAnimLine.lineShadow.renderOrder = renderOrder - 1;
    scene.add(newAnimLine.lineGroup);
  });
}

function removeLine(line) {
  let alpha = {alpha:1.};
  let fadeTween = new TWEEN.Tween(alpha)
    .to({
      alpha: 0.,
    }, 300)
    .easing(TWEEN.Easing.Quintic.Out)
    .onUpdate((val) => {
      //console.log(val);
      line.lineShadow.material.opacity= val.alpha;
      line.lineMesh.material.opacity= val.alpha;
    })
    .onComplete(() => {
      scene.remove(line.lineGroup);
    });
  fadeTween.start();
}


window.addEventListener('resize', onWindowResize, false)
window.addEventListener('orientationchange', onWindowResize, false)
function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
  render();
}

renderer.domElement.addEventListener('mouseup', onMouseUp, false);
renderer.domElement.addEventListener('mousedown', onMouseDown, false);
let mouseDown = false;
let mousePath = 0.;
let mouse = new Vector2();
function onMouseDown(event) {
  let newMouse = new THREE.Vector2();
  const rect = renderer.domElement.getBoundingClientRect();
  newMouse.x = ((event.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
  newMouse.y = -((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
  mousePath += Math.abs(mouse.length() - newMouse.length());
  let dir = new THREE.Vector2(0, 0);
  dir.subVectors(newMouse, mouse);
  mouse.x = newMouse.x;
  mouse.y = newMouse.y;
  makeNewLineFromEvent(mouse, dir);
  mouseDown = true;
  mousePath = 0.;
}
function onMouseUp(event) {
  mouseDown = false;

}
renderer.domElement.addEventListener('mousemove', onMouseMove, false);
function onMouseMove(event) {
  let newMouse = new Vector2();
  const rect = renderer.domElement.getBoundingClientRect();
  newMouse.x = ((event.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
  newMouse.y = -((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;
  camMouseOffset.x = newMouse.x * camBounds.x;
  camMouseOffset.y = newMouse.y * camBounds.y;
  planeMesh.position.x = newMouse.x * camBounds.x*.9;
  planeMesh.position.y = newMouse.y * camBounds.y*.9;
  
  if (mouseDown) {

    mousePath += Math.abs(mouse.length() - newMouse.length());
    let dir = new THREE.Vector2(0, 0);
    dir.subVectors(newMouse, mouse);
    //console.log(mouse, newMouse, dir);
    mouse.x = newMouse.x;
    mouse.y = newMouse.y;
    if (mousePath > .021) {

      makeNewLineFromEvent(mouse, dir);
      mousePath = 0.;
    }
  }
}
renderer.domElement.addEventListener('touchmove', onTouchMove, false);
renderer.domElement.addEventListener('touchstart', onTouchStart, false);
renderer.domElement.addEventListener('touchend', onTouchEnd, false);

function onTouchStart(e) {
  e.preventDefault();
  var x, y;
  var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
  var touch = evt.touches[0] || evt.changedTouches[0];
  onMouseDown(touch)
}

function onTouchEnd(event) {
  if (mouseDown !== false)
      mouseDown = false;
}

function onTouchMove(e) {
  e.preventDefault();
  var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
  var touch = evt.touches[0] || evt.changedTouches[0];
  onMouseMove(touch);
}

function transition(imageCallback){

  let time = 500;

  nextPallette();
  let prevBgCol = transitionPlane.material.color.clone();
  let nextBgCol = new THREE.Color(getBgColour());
  // fade out
  let alpha = {alpha: transitionPlane.material.opacity};
  let fadeOut = new TWEEN.Tween(alpha)
    .to({
      alpha: 1.,
    }, time)
    .easing(TWEEN.Easing.Quintic.Out)
    .onUpdate((val) => {
      //console.log(val);
      transitionPlane.material.opacity= val.alpha;
      transitionPlane.material.color.r = THREE.MathUtils.lerp(prevBgCol.r, nextBgCol.r, val.alpha);
      transitionPlane.material.color.g = THREE.MathUtils.lerp(prevBgCol.g, nextBgCol.g, val.alpha);
      transitionPlane.material.color.b = THREE.MathUtils.lerp(prevBgCol.b, nextBgCol.b, val.alpha);
    })
    .onComplete(() => {
      switchColours();
      imageCallback();
    });
  let fadeIn = new TWEEN.Tween(alpha)
    .to({
      alpha: 0.,
    }, time)
    .easing(TWEEN.Easing.Quintic.In)
    .onUpdate((val) => {
      //console.log(val);
      transitionPlane.material.opacity = val.alpha;
    })
    .onComplete(() => {

    });
  fadeOut.chain(fadeIn);
  fadeOut.start();

}

function nextPallette(){
  //new pallete index
  pIndex++;
  if(pIndex >= pallettes.length)
    pIndex = 0;
}

function switchColours() {

  //recolour BGs
  canvas.material.color.setHex(getBgColour());
  transitionPlane.material.color.setHex(getBgColour());
  scene.background.setHex(getBgColour());
  planeMesh.material.color.setHex(getBgColour());
  planeMesh.material.color.offsetHSL(-.01,0.01,-.01);
  //recolour anim lines
  animLines.forEach((line) => {
    let colour = new THREE.Color(getColours()[Math.floor(Math.random()*getColours().length)]);
    while (colour.getHexString() === new THREE.Color(getBgColour()).getHexString())
      colour = new THREE.Color(getColours()[Math.floor(Math.random() * getColours().length)]);
    line.lineMesh.material.color = colour;
  })
  generateBG();
}

function nextImage() {
  textureIndex++;
  if (textureIndex >= imageTextures.length)
    textureIndex = 0;
  setPlaneTexture(imageTextures[textureIndex]);
}
function prevImage() {
  textureIndex--;
  if (textureIndex < 0)
    textureIndex = imageTextures.length - 1;
  setPlaneTexture(imageTextures[textureIndex]);
}


window.addEventListener('keyup', onKeyUp, false)
function onKeyUp(event) {
  //console.log(event.keyCode);
  switch (event.keyCode) {
    case 38: // up
      transition(nextImage);
      break;
    case 39: // right
      transition(nextImage);
      break
    case 40: // down
      transition(prevImage);
      break;
    case 37: // left
      transition(prevImage);
      break
    case 32:
      saveCanvas();
    default:
      break;
  }
}

let dots = [];

function generateBG(){
  
  dots.forEach((dot) => {
    scene.remove(dot);
  });
  dots = [];

  let numDots = 300;
  for (let i = 0; i < numDots; i++){
    let r = (Math.sin(i)+1) ;
    if(r > 1.8){
      r =(Math.sin(i+45)+1) *.3 ;
    }
    else
      r *=.2;

    const geometry = new THREE.CircleGeometry( r, 30 );
    let colour = new THREE.Color(getColours()[Math.floor(Math.random()*getColours().length)]);
    const material = new THREE.MeshBasicMaterial({ transparent: true, color: colour, depthTest: false,  depthWrite:false  });
    const circle = new THREE.Mesh( geometry, material );
    let renderOrder = 1+Math.floor(Math.random()*5.)
    circle.renderOrder = renderOrder;
    scene.add( circle );
    let span = 15
    circle.position.z = Math.random()*-15;
    circle.position.x = -span+Math.random()*span*2.3;
    circle.position.y = -span+Math.random()*span*2.3;
    dots.push(circle);
  }

  for (let i = 0; i < 10; i++){
    let r = (Math.sin(i)*2.+1.5) ;

    const geometry = new THREE.CircleGeometry( r, 50 );
    let colour = new THREE.Color(getColours()[Math.floor(Math.random()*getColours().length)]);
    while (colour.getHexString() === new THREE.Color(getBgColour()).getHexString())
      colour = new THREE.Color(getColours()[Math.floor(Math.random() * getColours().length)]);
    const material = new THREE.MeshBasicMaterial({ transparent: true, opacity: 1.05,color: colour, depthTest: false,  depthWrite:false  });
    const circle = new THREE.Mesh( geometry, material );
    circle.renderOrder = 1;
    scene.add( circle );
    let span = 10
    circle.position.z = -6 + Math.random()*-2;
    circle.position.x = -span+Math.random()*span*2;
    circle.position.y = -span+Math.random()*span*2;
    dots.push(circle);
  }

}
generateBG();
transition(nextImage);

var composer = new EffectComposer(renderer);
var renderPass = new RenderPass(scene, camera);
composer.addPass(renderPass);


let vertShader =`
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix 
      * modelViewMatrix 
      * vec4( position, 1.0 );
  }`

let fragShader = `
  uniform float amount;
  uniform sampler2D tDiffuse;
  varying vec2 vUv;

  float random( vec2 p )
  {
    vec2 K1 = vec2(
      23.14069263277926, // e^pi (Gelfond's constant)
      2.665144142690225 // 2^sqrt(2) (Gelfondâ€“Schneider constant)
    );
    return fract( cos( dot(p,K1) ) * 12345.6789 );
  }

  void main() {

    vec4 color = texture2D( tDiffuse, vUv );
    vec2 uvRandom = vUv;
    float div = 0.002;
    uvRandom.x = div*round(uvRandom.x/div);
    uvRandom.y = div*round(uvRandom.y/div);
    uvRandom.y *= random(vec2(uvRandom.y,amount));
    color.rgb += random(uvRandom)*0.03;
    gl_FragColor = vec4( color  );
  }`
var myEffect = {
  uniforms: {
    "tDiffuse": { value: null },
    "amount": { value: 1}
  },
  vertexShader: vertShader,
  fragmentShader: fragShader
}

var customPass = new ShaderPass(myEffect);
customPass.renderToScreen = true;
composer.addPass(customPass);



var animate = function (timestamp) {

  requestAnimationFrame(animate)
  //controls.update();
  stats.update()
  //renderStats.update(renderer);
  TWEEN.update()
  animLines.forEach(line => {
    line.update();
  })
  //controls.update();
  camAnimOffset.x = Math.sin(timestamp*.0005)*0.1;
  camAnimOffset.y = Math.cos(timestamp*.00006)*0.2;
  camera.position.x = camMouseOffset.x ;
  camera.position.x += camAnimOffset.x ;
  camera.position.y = camMouseOffset.y ;
  camera.position.y += camAnimOffset.y ;

  dots.forEach(function(dot, index){
    dot.position.x -= .02 + (Math.sin(THREE.MathUtils.seededRandom(index)*2.) +1.)*.01;
    dot.position.y -= (Math.sin(index*THREE.MathUtils.seededRandom(index*index)*Math.PI))*.01;
    let spanX = 25;
    let spanY = 10;
    if(dot.position.x < -spanX)
      dot.position.x = spanX;
    if (dot.position.y < -spanY)
      dot.position.y = spanY;
    if (dot.position.y > spanY)
      dot.position.y = -spanY;

  })

  customPass.uniforms["amount"].value = timestamp;

  composer.render();

};

function render() {


	// monitored code goes here

  renderer.render(scene, camera);

}




// make buttons
var btnPrev = document.createElement("BUTTON");   // Create a <button> element
btnPrev.style.fontFamily = "Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif"
btnPrev.innerHTML = "&#8249;";                   // Insert text
if(!isMobile)
  btnPrev.style.fontSize = "1.3em"
btnPrev.style.width= "1.8em";
btnPrev.style.height= "1.8em";
btnPrev.style.background= "rgba(0, 0, 0, 0.2)";
btnPrev.style.border = "1px solid";
btnPrev.style.borderColor = "white";
btnPrev.style.bottom = "1%";
btnPrev.style.textAlign = 'center';
btnPrev.style.color = '#fff';
btnPrev.style.position = 'absolute';
btnPrev.style.left = '2.3em';
btnPrev.style.margin = '.1em';
btnPrev.style.bottom = '2.3em';
document.body.appendChild(btnPrev);
btnPrev.addEventListener("click", function () { transition(prevImage) }, false);

var btnNext = document.createElement("BUTTON");   // Create a <button> element
btnNext.style.fontFamily = "Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif"
btnNext.innerHTML = "&#8250;";                   // Insert text
if(!isMobile)
  btnNext.style.fontSize = "1.3em"
btnNext.style.width= "1.8em";
btnNext.style.height= "1.8em";
btnNext.style.background= "rgba(0, 0, 0, 0.2)";
btnNext.style.border = "1px solid";
btnNext.style.borderColor = "white";
btnNext.style.bottom = "1%";
btnNext.style.textAlign = 'center';
btnNext.style.color = '#fff';
btnNext.style.position = 'absolute';
btnNext.style.right= '2.3em';
btnNext.style.margin = '.1em';
btnNext.style.bottom = '2.3em';
document.body.appendChild(btnNext);
btnNext.addEventListener("click", function () { transition(nextImage) }, false);

var btnSave= document.createElement("BUTTON");   // Create a <button> element

btnSave.style.fontFamily = "Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif"
btnSave.innerHTML = "&#8226;";                   // Insert text
if(!isMobile)
  btnSave.style.fontSize = "1.3em"
btnSave.style.width= "1.8em";
btnSave.style.height= "1.8em";
btnSave.style.background= "rgba(0, 0, 0, 0.2)";
btnSave.style.border = "1px solid";
btnSave.style.borderColor = "white";
btnSave.style.bottom = "1%";
btnSave.style.textAlign = 'center';
btnSave.style.color = '#fff';
btnSave.style.position = 'absolute';
btnSave.style.right= '2.3em';
btnSave.style.margin = '.1em';
btnSave.style.top = '2.3em';
document.body.appendChild(btnSave);
btnSave.addEventListener("click", function () { saveCanvas() }, false);
btnNext.onmouseover = function() {
  //Hovering
  btnNext.style.background = "rgba(0, 0, 0, 0.5)";
}
btnNext.onmouseleave = function () {
  //Hovering
  btnNext.style.background = "rgba(0, 0, 0, 0.2)";
}
btnPrev.onmouseover = function() {
  //Hovering
  btnPrev.style.background = "rgba(0, 0, 0, 0.5)";
}
btnPrev.onmouseleave = function () {
  //Hovering
  btnPrev.style.background = "rgba(0, 0, 0, 0.2)";
}

btnSave.onmouseover = function() {
  //Hovering
  btnSave.style.background = "rgba(0, 0, 0, 0.5)";
}
btnSave.onmouseleave = function () {
  //Hovering
  btnSave.style.background = "rgba(0, 0, 0, 0.2)";
}



var instructionText = document.createElement("TEXT");   // Create a <button> element
instructionText.innerHTML = "press &#8249; &#8250; to change shape <br> press &#8226; to save image";                   // Insert text
if(!isMobile)
  instructionText.style.fontSize = "1.3em"
instructionText.style.fontFamily = "Consolas, Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif"
instructionText.style.textShadow= "2px 2px 3px #000000";
instructionText.style.width= "60.8em";
instructionText.style.height= "1.8em";
instructionText.style.background= "transparent";
instructionText.style.border = "none";
instructionText.style.bottom = "1%";
instructionText.style.textAlign = 'left';
instructionText.style.color = '#ddd';
instructionText.style.position = 'absolute';
instructionText.style.left= '2.3em';
instructionText.style.margin = '.1em';
instructionText.style.top = '2.3em';
document.body.appendChild(instructionText);


window.requestAnimationFrame(animate);



